import { z } from 'zod';

export const Environment = z.object({
  production: z.boolean(),
  trackjsToken: z.string().optional(),
  adobeLaunchKey: z.string().optional(),
  classicUiHost: z.string().optional(),
  coveoClientId: z.string().optional(),
  coveoEndpoint: z.string().optional(),
  defaultTokenEndpoint: z.string().optional(),
  platformUrl: z.string().optional(),
  searchHub: z.string().optional(),
  organizationId: z.string().optional(),
  apiKey: z.string().optional(),
});

export type Environment = z.infer<typeof Environment>;
